// Google AdSense loader — activates automatically once REACT_APP_ADSENSE_CLIENT is set in .env
// Loader is idempotent, injects the AdSense script + verification meta tag once.

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;

export function loadAdSense() {
    if (!CLIENT) return; // not configured yet
    if (typeof window === "undefined") return;
    if (window.__rc_adsense_loaded) return;
    window.__rc_adsense_loaded = true;

    // Verification meta tag
    const meta = document.createElement("meta");
    meta.name = "google-adsense-account";
    meta.content = CLIENT;
    document.head.appendChild(meta);

    // Loader script
    const s = document.createElement("script");
    s.async = true;
    s.crossOrigin = "anonymous";
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
    document.head.appendChild(s);
}

export const ADSENSE_CLIENT = CLIENT;
export const ADSENSE_SLOTS = {
    left: process.env.REACT_APP_ADSENSE_SLOT_LEFT,
    right: process.env.REACT_APP_ADSENSE_SLOT_RIGHT,
    inline: process.env.REACT_APP_ADSENSE_SLOT_INLINE,
};

export function pushAd() {
    try {
        if (!CLIENT) return;
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
        // AdSense may throw if already filled — safe to ignore
    }
}
